import React, { useState, useContext, useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import { Auth, Hub } from 'aws-amplify';
import { SnipcartContext } from 'gatsby-plugin-snipcart-advanced/context';

import { SideMenu } from '../SideMenu';
import { Register } from '../sections';
import { LegacyAccount } from '../sections';
import { Login } from '../Login';
import { Modal } from '../Modal';
import { modalConstants } from '../../constants';
import { UserContext } from 'contexts';
import { localstorageHelper, queryHelper, domHelper } from 'helpers';
import { cognitoService } from 'services';
import { Tooltip } from '../Tooltip';

import {
  Nav,
  NavIconSection,
  NavIcon,
  NavButton,
  NavButtonSection,
} from './styles';

import UserIcon from '/static/icons/nav/person.svg';
import SearchIcon from '/static/icons/nav/search.svg';
import CartIcon from '/static/icons/nav/cart.svg';
import MenuIcon from '/static/icons/nav/menu.svg';

export const NavBar = props => {
  const {
    data: { buttonGroup, iconGroup },
  } = props;
  const [activeModal, setActiveModal] = useState(modalConstants.HIDDEN);
  const { user, setUser, createNotification } = useContext(UserContext); 
  // Removed loading due to bug (uncessary page reloads) ... Context API to update user state
  const { state } = useContext(SnipcartContext); // state of the snipcart
  /**
   * State for login modal
   */
  const [loginData, setLoginData] = useState({
    user: {
      email: '',
      password: '',
      authCode: '',
      newPassword: '',
      forgotEmail: '',
    },
    meta: { error: '', pageIndex: 0, bLoading: false },
  });

  /**
   * State for login modal
   */
  const [registerData, setRegisterData] = useState({
    user: { email: '', password: '', authCode: '' },
    meta: { error: '', signupStage: 0, bLoading: false },
  });

  const [legacyAccountData, setLegacyAccountData] = useState({

  });

  const [isLoginTooltipActive, setIsLoginTooltipActive] = useState(false);

  const closeModal = () => {
    // Close an opening modal
    setActiveModal(modalConstants.HIDDEN);
  };

  const handleSignOut = () => {
    // Sign-out method
    cognitoService
      .signOut()
      .then(() => {
        localstorageHelper.removeUser();
        setUser(null); // Update the user state context to null
        const url = domHelper.getLocation();
        /** Redirect to home page on my-account page */
        if (url.indexOf('my-account') >= 0) navigate('/');
        createNotification("warning", "You're logged out");
      })
      .catch(err => console.log('eror:', err));
  };

  const handleConfirm = email => {
    setRegisterData({
      ...registerData,
      user: { ...registerData.user, email },
      meta: { ...registerData.meta, signupStage: 1 },
    });
    setActiveModal(modalConstants.REGISTER);
  };

  async function checkUser() {
    const user = await Auth.currentAuthenticatedUser()
    ////console.log('User: ',user);
  }

  const handleLogin = ev => {
    setLoginData({ ...loginData, meta: { ...loginData.meta, pageIndex: 0 } });
    setActiveModal(modalConstants.LOGIN);
  };
  return (
    <Nav>
      <NavButtonSection>
        {user && (
          <NavButton>
            <a
              className="blue-link"
              id="signout-button"
              onClick={handleSignOut}
            >
              Sign Out
            </a>
          </NavButton>
        )}
        {!user && (
          <>
            <NavButton className="login-button">
              <a
                id="login-button"
                className={'blue-link'} // to apply blue color for only signin and signup
                onClick={() => setActiveModal(modalConstants.LOGIN)} // toggle the login modal
              >
                {buttonGroup[0].description}
              </a>
            </NavButton>
            <span>Or</span>
            <NavButton>
              <a
                id="register-button"
                className={'blue-link'} // to apply blue color for only signin and signup
                onClick={() => setActiveModal(modalConstants.REGISTER)} //toggle the register modal
              >
                {buttonGroup[1].description}
              </a>
            </NavButton>
            <NavButton>
              <a
                id="legacyaccount-button"
                className={'blue-link'} // to apply blue color for only signin and signup
                onClick={() => setActiveModal(modalConstants.LEGACYACCOUNT)} //toggle the register modal
              >
                simplysay.sg
              </a>
            </NavButton>
          </>
        )}
        <NavButton>
          <Link to={queryHelper.getLinkUrl(buttonGroup[2].link)}>
            {buttonGroup[2].description}
          </Link>
        </NavButton>
        <NavButton>
          <Link to={queryHelper.getLinkUrl(buttonGroup[3].link)}>
            {buttonGroup[3].description}
          </Link>
        </NavButton>
      </NavButtonSection>

      <NavIconSection>
        <NavIcon mobileHidden>
          <Link to="/search">
            <SearchIcon />
          </Link>
        </NavIcon>
        {user && (
          <NavIcon mobileHidden>
            <Link to="/my-account">
              <UserIcon />
            </Link>
          </NavIcon>
        )}
        <NavIcon>
          <button className="snipcart-checkout" id="snipcart-checkout">
            <CartIcon />
            {state.cartQuantity > 0 && (
              <span className="cart-count">{state.cartQuantity}</span>
            )}
          </button>
        </NavIcon>

        <NavIcon
          onClick={() => setIsLoginTooltipActive(!isLoginTooltipActive)}
          desktopHidden
        >
          <UserIcon />
          {isLoginTooltipActive && (
            <Tooltip>
              {user ? (
                <NavButton>
                  <a
                    className="auth-button"
                    id="signout-button"
                    onClick={handleSignOut}
                  >
                    Sign Out
                  </a>
                </NavButton>
              ) : (
                <>
                  <NavButton className="auth-button">
                    <a
                      id="login-button"
                      onClick={() => setActiveModal(modalConstants.LOGIN)} // toggle the login modal
                    >
                      {buttonGroup[0].description}
                    </a>
                  </NavButton>
                  <NavButton className="auth-button">
                    <a
                      id="register-button"
                      onClick={() => setActiveModal(modalConstants.REGISTER)} //toggle the register modal
                    >
                      {buttonGroup[1].description}
                    </a>
                  </NavButton>
                </>
              )}
            </Tooltip>
          )}
        </NavIcon>

        <NavIcon onClick={() => setActiveModal(modalConstants.SIDEMENU)}>
          <MenuIcon />
        </NavIcon>
      </NavIconSection>

      <Modal isActive={activeModal} hideModal={closeModal}>
        {activeModal === modalConstants.SIDEMENU && (
          <SideMenu onClose={closeModal} />
        )}
        {activeModal === modalConstants.LOGIN && (
          <Login
            data={loginData}
            setData={setLoginData}
            onConfirm={handleConfirm}
            onClose={closeModal}
            onRegister={ev => setActiveModal(modalConstants.REGISTER)}
            onLegacyAccount={ev => setActiveModal(modalConstants.LEGACYACCOUNT)}
          />
        )}
        {activeModal === modalConstants.REGISTER && (
          <Register
            data={registerData}
            setData={setRegisterData}
            onClose={closeModal}
            onLogin={handleLogin}
          />
        )}
        {/*{{activeModal === modalConstants.LEGACYACCOUNT && (
          <LegacyAccount
            onClose={closeModal}
            onLogin={handleLogin}
            onRegister={ev => setActiveModal(modalConstants.REGISTER)}
          />
        )}*/}
      </Modal>
    </Nav>
  );
};
